import React, { useContext } from "react"

import { useSnackbar } from "notistack"
import RegistradorContext from "../../../../contexts/registradorContext"

import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Slide from "@material-ui/core/Slide"
import PrintIcon from "@material-ui/icons/Print"
import { Col, Row } from "react-bootstrap"

import { fecharmesa } from "../../../../services/integracao"

import { RegistrarLogErro } from "../../../../services/clientefiel"
import useAppStore from "../../../../stores/AppStore"
import useLoadingStore from "../../../../stores/LoadingStore"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export default function Index() {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const setLoading = useLoadingStore(s => s.setLoading)

    const {
        finalizarMesa,
        setFinalizarMesa,
        cadastrarUsuario,
        setOpenGerenciarMesa,
        setOpenGerenciarPedidosMesa,
        setListaMesas,
        setPedidosDaMesa,
        pedidosDaMesa,
    } = useContext(RegistradorContext)

    const mandarImprimir = async (texto, qtd) => {
        try {
            if (configuracoes.user?.parametros.assinaturaLimitada === true) {
                alertStart(
                    "Não foi impresso, porque sua assinatura está limitada por inadimplência.",
                    "info"
                )
                return false
            }

            document.getElementById("rootPrint").innerHTML = texto.replace(
                /(?:\r\n|\r|\n)/g,
                "<br>"
            )

            for (var j = 0; j < qtd; j++) {
                window.print()
            }
        } catch (error) {
            console.log("Não foi possível imprimir", error)
            RegistrarLogErro(error, "mandarImprimir")
        }
    }

    const fecharPedidoMesa = async pedidosDaMesa => {
        try {
            setLoading(true)
            const response = await fecharmesa(autorizacao, pedidosDaMesa)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                setLoading(false)
                return false
            }
            alertStart(`Mesa ${pedidosDaMesa.numeroMesa} fechada com sucesso!`, "success")

            setFinalizarMesa(false)
            setPedidosDaMesa({})
            setListaMesas([])
            setOpenGerenciarPedidosMesa(false)
            setOpenGerenciarMesa(false)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "fecharPedidoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const { enqueueSnackbar } = useSnackbar()

    const configuracoes = useAppStore(s => s.configuracoes)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    return finalizarMesa ? (
        <Dialog
            open={finalizarMesa}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setFinalizarMesa(false)}
        >
            <form onSubmit={cadastrarUsuario}>
                <DialogTitle>{`Fechar Mesa ${pedidosDaMesa.numeroMesa}`}</DialogTitle>
                <DialogContent>
                    {pedidosDaMesa.pedidosMesa.map((pedido, index) => (
                        <Row style={{ margin: "7px 0" }} key={index}>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    style={{ background: "#d8d8d8" }}
                                    fullWidth
                                    onClick={() => {
                                        mandarImprimir(pedido?.textoImpressao, 1)
                                    }}
                                >
                                    <PrintIcon style={{ marginRight: "10px" }} />
                                    {index + 1}º Pedido{" "}
                                    {Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(pedido.valorTotal)}
                                </Button>
                            </Col>
                        </Row>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setFinalizarMesa(false)
                        }}
                    >
                        cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            mandarImprimir(pedidosDaMesa.impressao, 1)
                        }}
                        style={{ color: "#28a745" }}
                    >
                        Imprimir Todas
                    </Button>

                    <Button
                        onClick={() => {
                            fecharPedidoMesa(pedidosDaMesa)
                        }}
                        style={{ color: "white", background: "#dc3545" }}
                    >
                        Fechar Mesa
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
